import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { EVENT_NAME, ENABLED_FEATURES, APP } from 'appenv';
import Routes from 'Routes';
import { useDispatch, batch } from 'react-redux';
import { fetchExhibitors } from 'models/exhibitors';
import { fetchWebinars } from 'models/webinars';
import { fetchXtraEvent } from 'models/event';
import { fetchBanners } from 'models/banners';

import AboutPage from 'pages/about/AboutPage';
import { localizationSlice } from 'models/localization';
import NetworkCheckModal from 'components/modals/network_check';
import ContentPageFrame from 'components/ContentPageFrame';
import { fetchDefaultBookmarks } from 'models/defaultBookmarks';
import AuthRoute from './AuthRoute';
import MainLobbyContainer from '../pages/main_lobby/MainLobbyContainer';
import BoothProfileRootContainer from '../pages/booths';
import HallPage from '../pages/hall/HallPage';
import WebinarPageContainer from '../pages/webinar/WebinarPageContainer';
import SearchResultContainer from '../pages/search/SearchResultContainer';
import LandingTemplateSwitch from '../pages/landing/LandingTemplateSwitch';
import PageNoFound from '../pages/PageNoFound';
import WebinarDetailContainer from '../pages/webinar_detail/WebinarDetailContainer';
import WebinarSpeakerDetailsContainer from '../pages/webinar_detail/speaker_detail/WebinarSpeakerDetailsContainer';
import ParticipantPageContainer from '../pages/participant/ParticipantPageContainer';

const AppRouter = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchXtraEvent()).then(({ payload: eventPayload }) => {
      batch(() => {
        if (ENABLED_FEATURES.cmsBanner) dispatch(fetchBanners());
        if (ENABLED_FEATURES.defaultBookmarks) dispatch(fetchDefaultBookmarks());
        dispatch(localizationSlice.actions.setEventTimeZone(eventPayload[0].timezone));
        dispatch(fetchExhibitors());
        dispatch(fetchWebinars(eventPayload[0]));
      });
    });
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{EVENT_NAME}</title>
        <meta name="description" content={EVENT_NAME} />
      </Helmet>
      {ENABLED_FEATURES.networkCheck && <NetworkCheckModal />}
      <ContentPageFrame>
        <Switch>
          {APP === 'ms624' && (
            <AuthRoute
              exact
              path="/about"
              route="about"
              component={AboutPage}
            />
          )}
          <AuthRoute
            exact
            path={[Routes.root, Routes.lobby]}
            route="lobby"
            component={MainLobbyContainer}
          />
          <AuthRoute
            path={Routes.booth()}
            route="booth"
            component={BoothProfileRootContainer}
          />
          <AuthRoute
            exact
            path={Routes.hall}
            route="hall"
            component={HallPage}
          />
          <AuthRoute
            exact
            path={Routes.webinar}
            route="webinar"
            component={WebinarPageContainer}
          />
          <AuthRoute
            exact
            path={Routes.webinarSpeaker()}
            route="webinar"
            component={WebinarSpeakerDetailsContainer}
          />
          <AuthRoute
            exact
            path={Routes.webinarSession()}
            route="webinar"
            component={WebinarDetailContainer}
          />
          <AuthRoute
            exact
            path={Routes.participant}
            route="participant"
            component={ParticipantPageContainer}
          />
          <AuthRoute
            exact
            path={Routes.search}
            route="search"
            component={SearchResultContainer}
          />
          <AuthRoute
            exact
            path={Routes.landing}
            route="landing"
            component={LandingTemplateSwitch}
          />
          <Route component={PageNoFound} />
        </Switch>
      </ContentPageFrame>
    </BrowserRouter>
  );
};

export default AppRouter;
